import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { defaultShouldDehydrateMutation, defaultShouldDehydrateQuery } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import localforage from 'localforage'
import { PropsWithChildren, useState } from 'react'

import { createQueryClient } from '@/integrations/react-query'

export const QueryProvider = ({ children }: PropsWithChildren) => {
  const [queryClient] = useState(() => createQueryClient())
  const [asyncPersister] = useState(() =>
    createAsyncStoragePersister({
      storage: localforage,
    }),
  )

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: asyncPersister,
        // Queries and mutations can opt out of disk persistence (kiosk data on a shared device,
        // blobs). Paused mutations are persisted by default — including their variables, which
        // for the kiosk would mean a PIN or password written to IndexedDB.
        dehydrateOptions: {
          shouldDehydrateQuery: query =>
            defaultShouldDehydrateQuery(query) && query.meta?.persist !== false,
          shouldDehydrateMutation: mutation =>
            defaultShouldDehydrateMutation(mutation) && mutation.meta?.persist !== false,
        },
      }}
    >
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  )
}
